/* eslint-disable import/no-duplicates */
import creditAgricole from '../public/creditagricole.png';
import allie1Mobile from '../public/img/allie-1-mobile.jpg';
import allie1 from '../public/img/allie-1.jpg';
import allie2 from '../public/img/allie-2.jpg';
import appStore from '../public/img/app/Download_on_the_App_Store_Badge_FR_RGB_wht_100217.svg';
import googlePlay from '../public/img/app/GetItOnGooglePlay_Badge_Web_color_French.png';
import landingAppFunctionalityCours from '../public/img/app/landing-page-app-cours.png';
import landingAppFunctionalityGraphics from '../public/img/app/landing-page-app-graphics.png';
import landingAppFunctionalityJournal from '../public/img/app/landing-page-app-journal.png';
import landingAppFunctionalityMeteo from '../public/img/app/landing-page-app-meteo.png';
import landingAppFunctionalityNotifications from '../public/img/app/landing-page-app-notif.png';
import landingAppFunctionalityRadar from '../public/img/app/landing-page-app-radar.png';
import backgroundPlv from '../public/img/background-plv.jpg';
import connexionMobile from '../public/img/connexion-768x167.jpg';
import connexion from '../public/img/connexion-1440x300.jpg';
import connexionBienvenueMobile from '../public/img/connexion-bienvenue-586x446.jpg';
import connexionBienvenueProMobile from '../public/img/connexion-bienvenue-pro-586x446.jpg';
import connexionBienvenuePro from '../public/img/connexion-bienvenue-pro.jpg';
import connexionBienvenue from '../public/img/connexion-bienvenue.jpg';
import JeuSalonAutomneMobile from '../public/img/game/Jeu-Pleinchamp-ENLIGNE.jpg';
import JeuSalonAutomne from '../public/img/game/Jeu-Pleinchamp-ENLIGNE.jpg';
import villageByCaBlack from '../public/img/innovation/village_by_ca_black-200x160.png';
import villageByCaBlackMobile from '../public/img/innovation/village_by_ca_black-200x160.png';
import villageByCaWhiteMobile from '../public/img/innovation/village_by_ca_white-200x160.png';
import villageByCaWhite from '../public/img/innovation/village_by_ca_white.png';
import inscriptionMobile from '../public/img/inscription-768x167.jpg';
import inscription from '../public/img/inscription-1440x300.jpg';
import journalMeteoMobile from '../public/img/journal/journal-meteo-738x555.webp';
import journalMeteo from '../public/img/journal/journal-meteo.webp';
import journalProMobile from '../public/img/journal/journal-pro-696x575.webp';
import journalPro from '../public/img/journal/journal-pro.webp';
import journalStockMobile from '../public/img/journal/journal-stocks-738x555.webp';
import journalStock from '../public/img/journal/journal-stocks.webp';
import notificationMobile from '../public/img/notifications-768x167.jpg';
import notification from '../public/img/notifications-1440x300.jpg';
import preferencesMobile from '../public/img/preferences-768x167.jpg';
import preferences from '../public/img/preferences-1440x300.jpg';
import profilMobile from '../public/img/profil-768x167.jpg';
import profil from '../public/img/profil-1440x300.jpg';
import maskableIconMobile from '../public/maskable_icon-192x192.png';
import maskableIcon from '../public/maskable_icon.png';

export {
  JeuSalonAutomne,
  JeuSalonAutomneMobile,
  allie1Mobile,
  allie1,
  allie2,
  backgroundPlv,
  connexion,
  connexionBienvenue,
  connexionBienvenueMobile,
  connexionBienvenuePro,
  connexionBienvenueProMobile,
  connexionMobile,
  creditAgricole,
  inscription,
  inscriptionMobile,
  journalMeteo,
  journalMeteoMobile,
  journalPro,
  journalProMobile,
  journalStock,
  journalStockMobile,
  maskableIcon,
  maskableIconMobile,
  notification,
  notificationMobile,
  preferences,
  preferencesMobile,
  profil,
  profilMobile,
  villageByCaBlack,
  villageByCaBlackMobile,
  villageByCaWhite,
  villageByCaWhiteMobile,
  googlePlay,
  appStore,
  landingAppFunctionalityMeteo,
  landingAppFunctionalityRadar,
  landingAppFunctionalityJournal,
  landingAppFunctionalityGraphics,
  landingAppFunctionalityCours,
  landingAppFunctionalityNotifications,
};
